export function addUpgradeButton(playerConfig: any) {
  //check if button is already there
  const upgradeButton = document.querySelector('.skip_intro_upgrade');
  if (upgradeButton) {
    return;
  }
  const upgradeData = playerConfig?.upgradeData;
  const isUpgrade = !!upgradeData;
  const skipIntroContainer = document.querySelector('.skip_intro_container');

  //inject upgrade button
  if (isUpgrade && skipIntroContainer) {
    const upgradeButton = document.createElement('DIV');
    upgradeButton.className = 'skip_intro_upgrade';
    const planName = upgradeData?.title ?? '';
    if (window.innerWidth <= 600) {
      upgradeButton.innerHTML = `<span>Upgrade</span>`;
    } else {
      upgradeButton.innerHTML = `<span>Upgrade to ${planName}</span>`;
    }
    upgradeButton.addEventListener('click', () => {
      window.location.href = '/myaccount/subscription';
    });
    skipIntroContainer?.insertBefore(
      upgradeButton,
      skipIntroContainer.firstChild
    );
  }
}

export function removeUpgradeButton() {
  const upgradeButton = document.querySelector('.skip_intro_upgrade');
  upgradeButton?.remove();
}
